import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  componentTitle: {
    fontSize: "14px",
    lineHeight: "18px",
    color: "#465869",
    marginBottom: "3px",
    fontWeight: "bold",
  },
  photoCard: {
    position: "relative",
    marginRight: "15px",
    marginTop: "15px",
    marginBottom: "24px",
  },
  image: {
    paddingTop: "10px",
    paddingRight: "10px",
    cursor: "pointer",
  },
  buttonDeletePhoto: {
    padding: "5px",
    position: "absolute",
    right: 0,
    background: "#F97066",
    "&:hover": {
      background: "#F97066",
      opacity: 0.9,
    },
  },
  icon: {
    fontSize: "10px",
  },
}));

export default styles;
